import * as React from 'react';
import classNames from 'styles/utils/classNames';
import {
  getOptionFlowRowSentimentClassName,
  getOptionFlowSideCode,
} from 'utils/shared/trades/getOptionFlowRowSentiment';
import { getOptionFlowSideIntelligence } from 'utils/shared/trades/getOptionFlowSideIntelligence';
import { Trade } from 'utils/shared/trades/types';

type OptionFlowTradeSideProps = {
  trade?: Partial<Trade> | null;
  className?: string;
  showTooltip?: boolean;
};

const OptionFlowTradeSide: React.FC<OptionFlowTradeSideProps> = ({
  trade,
  className,
  showTooltip = true,
}) => {
  const sideCode = getOptionFlowSideCode(trade);
  const sentimentClassName = getOptionFlowRowSentimentClassName(trade);
  const sideIntelligence = getOptionFlowSideIntelligence(trade);

  return (
    <span
      title={showTooltip ? sideIntelligence.tooltip : undefined}
      aria-label={sideIntelligence.tooltip}
      className={classNames(
        'inline-flex min-w-0 items-center gap-1 whitespace-nowrap font-semibold uppercase leading-none',
        sentimentClassName,
        className,
      )}
    >
      {sideCode ? (
        <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-current" />
      ) : null}
      <span>{sideCode || '-'}</span>
    </span>
  );
};

export default OptionFlowTradeSide;
